import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "../../core/services/user/user.service";
import { IActionOdataResult } from "../models/interfaces/action-result.interface";
import { IRegion } from "../models/interfaces/region.interface";
import { IParamObj, IParamQuery } from "../models/interfaces/param-query.interface";

@Injectable({
    providedIn: 'root'
})
export class RegionService {

    constructor(private http: HttpClient, private userService: UserService) { }
    /**
     * Returns an array of regions based on queryParams
     */
    public get(params?: IParamObj): Observable<Array<IRegion>> {
        const paramQuery: IParamQuery = (params) ? {params: params} : null;
        return this.getRegions().pipe(map((result) => result.value as Array<IRegion>));
    }

    private getRegions(paramQuery?: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/Regions', httpParams);
    }
}
